import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { SiteLayout } from "@/components/Layout";
import Home from "@/pages/Home";
import Watch from "@/pages/Watch";
import Spotlight from "@/pages/Spotlight";
import About from "@/pages/About";
import Cafe from "@/pages/Cafe";
import Cookbook from "@/pages/Cookbook";
import Events from "@/pages/Events";
import Press from "@/pages/Press";
import Contact from "@/pages/Contact";
import BeOnTheShow from "@/pages/BeOnTheShow";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import PersonDetail from "@/pages/PersonDetail";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import CartPage from "@/pages/CartPage";
import CheckoutPage from "@/pages/CheckoutPage";
import OrderConfirmation from "@/pages/OrderConfirmation";
import { CartProvider } from "@/lib/cart";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <CartProvider>
          <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/watch" element={<Watch />} />
            <Route path="/spotlight" element={<Spotlight />} />
            <Route path="/spotlight/:id" element={<PersonDetail type="guests" />} />
            <Route path="/cafe" element={<Cafe />} />
            <Route path="/cookbook" element={<Cookbook />} />
            <Route path="/events" element={<Events />} />
            <Route path="/press" element={<Press />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/be-on-the-show" element={<BeOnTheShow />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/confirmation" element={<OrderConfirmation />} />
            <Route path="/shop/:id" element={<ProductDetail />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/cast" element={<Navigate to="/about" replace />} />
            <Route path="/cast/:id" element={<Navigate to="/about" replace />} />
            <Route path="/guests" element={<Navigate to="/spotlight" replace />} />
            <Route path="/guests/:id" element={<PersonDetail type="guests" />} />
            <Route path="/where-to-watch" element={<Navigate to="/watch" replace />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </CartProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
